module.exports = __webpack_public_path__ + "img/feature_buy_id.61603f75.png";